import React, { useContext, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import config from "../../../config/config";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import { uploadAWS } from "../../../common/AWSHelper";
import { Modal } from "react-bootstrap";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  AWS_IMAGE_FOLDER_RECEIVING,
} from "../../../common/Constant";

import Select from "react-select";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import moment from "moment";
import { toastError, toastSuccess } from "../../../common/Toast";
import Expensecategoryrows from "../../../pages/MainPages/Receiving/Expensecatgeroryrows";
import ExpenseItemrows from "../../../pages/MainPages/Receiving/ExpenseItemrows";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";

const ExpenseQuickbook = (props) => {
  const paramObject = useParams();
  let navigate = useNavigate();
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [btnLoader, setBtnLoader] = useState({ Attachments: false });
  const [payeeoptions, setPayeeOptions] = useState([]);
  const [Account, setAccount] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedaccount, setSelectedAccount] = useState(0);
  const [selectedaccountbal, setselectedaccountbal] = useState(0);
  const [selectpayee, setselectpayee] = useState(0);
  const [payeetypeid, setpayeetypeid] = useState(0);
  const [localValues, setLocalValues] = useState({});
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState(0);

  const [referenceNumber, setReferenceNumber] = useState("");
  const [selectedtags, setSelectedtags] = useState([]);
  const [ExpenseTotal, setExpenseTotal] = useState(0);
  const [Categorydetiles, setcategorydetiles] = useState(true);
  const [itemdetiles, setitemdetiles] = useState(true);
  const [tag, setTag] = useState(0);
  const [memo, setmemo] = useState("");
  const [show, setShow] = useState(false);
  const [tagsdropdwonData, setTagsdropdwonData] = useState([]);
  const [showtag, setShowTag] = useState(false);
  const [AmountPaid, setAmountPaid] = useState(0);
  const [formValuesfortagmodel, setFormValuesforTagmodel] = useState({
    ID: 0,
    Tags: "",
  });
  const [rowsData, setRowsData] = useState(
    Array.from({ length: 2 }, (e, index) => ({
      id: 0,
      accountid: "",
      description: "",
      amount: 0,
      rowNumber: index + 1,
    }))
  );

  const [itemData, setitemData] = useState(
    Array.from({ length: 3 }, (e, index) => ({
      id: 0,
      itemid: "",
      sku: "",
      description: "",
      qty: 0,
      rate: 0,
      amount: 0,
      rowNumber: index + 1,
    }))
  );
  const [ExpenseDate, setexpensedate] = useState(
    moment().format("YYYY-MM-DDT00:00:00.000") + "Z"
  );

  // Quickbook  Key

  const [Quickbookaccount, setquickbookaccount] = useState(0);
  const [QuickbookPayee, setQuickbookPayee] = useState(0);
  const [trnQuickbookid, settrnQuickbookid] = useState(0);
  const [paymentQB, setpaymentQB] = useState("");
  const [QBPaymentmethod, setQBPaymentmethod] = useState(0);
  //Helper function
  const calculateTotal = () => {
    let Total = 0;

    Total +=
      rowsData?.reduce((acc, curr) => acc + Number(curr.amount || 0), 0) || 0;

    Total +=
      itemData?.reduce((acc, curr) => acc + Number(curr.amount || 0), 0) || 0;

    return Total;
  };

  const handleaccount = (e) => {
    setSelectedAccount(e.value);
    setquickbookaccount(e.QuickBookId);
    setselectedaccountbal(e.Amount);
    if (paramObject.id === undefined) {
      console.log(paramObject.id, "localstr");
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        Selectedaccount: e.value,
        selectedaccountbal: e.Amount,
        quickbookaccount: e.QuickBookId,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const Handelmemo = (e) => {
    console.log(e.target.value, "ggfrer");

    setmemo(e.target.value);

    if (paramObject.id === undefined) {
      console.log(paramObject.id, "localstr");
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        memo: e.target.value,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  // Aws upload image

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "SelectImage") {
          console.log("data: ", data);
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  const _handleFileChange = (e) => {
    console.log(e.currentTarget.files[0]);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      console.log(1);
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const handlepayee = (e) => {
    setselectpayee(e.value);
    setpayeetypeid(
      e.Type == "Supplier"
        ? 0
        : e.Type == "Customer"
        ? 1
        : e.Type == "Employee"
        ? 3
        : 0
    );
    setQuickbookPayee(e.QuickBookId);
    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        payee: e.value,
        payeeqb: e.QuickBookId,
        payeetypeid:
          e.Type == "Supplier"
            ? 0
            : e.Type == "Customer"
            ? 1
            : e.Type == "Employee"
            ? 3
            : 0,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };
  const handleChangePaymet = (e) => {
    setPaymentMethodId(e.value);
    setpaymentQB(e.label);
    setQBPaymentmethod(e.paymentquickbookid);

    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        paymentMethodId: e.value,
        Paymenttypename: e.label,
        qbPaymentmethod: e.paymentquickbookid,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const handleChangeRefno = (e) => {
    setReferenceNumber(e.target.value);
    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || "";
      const x = { ...localValue1, referenceNumber: referenceNumber };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const handleSelectedtags = (e) => {
    setSelectedtags(Array.isArray(e) ? e.map((x) => x.value) : []);
    // setSelectedtags(e);
  };
  const handleClose = () => setShow(false);
  const handeltagsmodelClose = () => setShowTag(false);
  const handeltagsmodelShow = () => setShowTag(true);

  const handleSubmitformodeltags = async (eventObject) => {
    if (eventObject.Tags === "") {
      toastError("Please Insert Tag Name");
      return;
    }
    setLoading(true);
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: 0,
          ecommerecetagid: 1,
          name: eventObject.Tags,
          tagtype: "Account",
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setLoading(false);
      });

    handleSubmitformodeltags();
  };

  const callback = (value, field) => {};

  // category rows handle

  const handleChangeTableRow = (index, evnt) => {
    console.log("event", evnt.target.name);
    let name, values;

    name = evnt.target.name;
    values = evnt.target.value;
    // quickbookid= evnt.target.quickbookid;
    console.log(name, values);
    const rowsInput = [...rowsData];
    rowsInput[index][name] = values;
    if (name == "accountid") {
      rowsInput[index]["accountquickbookid"] = evnt.target.quickbookid;
      rowsInput[index]["AccountName"] = evnt.target.AccountName;
      rowsInput[index]["QuickbookId"] = evnt.target.QuickbookId;
      rowsInput[index]["Module"] = "Accounts";
    }

    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || "";
      const x = { ...localValue1, Categorysection: rowsInput };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }

    setRowsData(rowsInput);
  };

  const deleteTableRows = (i) => {
    const filteredData = rowsData.filter((item, index) => index !== i);
    setRowsData([]);

    console.log(filteredData, "filteredDatadelete");
    setTimeout(() => {
      setRowsData(filteredData);
      if (paramObject.id === undefined) {
        const localValue1 =
          JSON.parse(localStorage.getItem("ExpenseDraft")) || "";
        const x = { ...localValue1, Categorysection: filteredData };
        setLocalValues(x);
        localStorage.setItem("ExpenseDraft", JSON.stringify(x));
      }
    }, 500);
  };

  // itemrows handle

  const handleChangeItemTableRow = (index, evnt) => {
    console.log("event", evnt.target.name);
    let name, values;

    name = evnt.target.name;
    values = evnt.target.value;
    // quickbookid= evnt.target.quickbookid;
    console.log(name, values);
    const rowsInput = [...itemData];
    rowsInput[index][name] = values;
    if (name == "itemid") {
      rowsInput[index]["qty"] = 1;
      rowsInput[index]["rate"] = evnt.target.Unitprice;
      rowsInput[index]["amount"] = 1 * evnt.target.Unitprice;
      rowsInput[index]["ItemId"] = evnt.target.ItemId;
      rowsInput[index]["VariationId"] = evnt.target.VariationId;
      rowsInput[index]["QuickbookId"] = evnt.target.QuickbookId;
      rowsInput[index]["Module"] = "Item";
    }

    if (name == "qty") {
      rowsInput[index]["amount"] = evnt.target.value * rowsInput[index]["rate"];
    }

    if (name == "rate") {
      rowsInput[index]["amount"] = rowsInput[index]["qty"] * evnt.target.value;
    }

    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || "";
      const x = { ...localValue1, Itemsection: rowsInput };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }

    setitemData(rowsInput);
  };

  const deleteitemTableRows = (i) => {
    const filteredData = itemData.filter((item, index) => index !== i);
    setitemData([]);

    console.log(filteredData, "filteredDatadelete");
    setTimeout(() => {
      setitemData(filteredData);
    }, 500);
  };

  const additemTableRows = () => {
    const rowsInput = {
      itemid: "",
      sku: "",
      description: "",
      qty: 0,
      rate: 0,
      amount: 0,
    };

    setitemData([...itemData, rowsInput]);
  };

  const clearitem = () => {
    setitemData([]);
  };

  const addTableRows = () => {
    const rowsInput = {
      accountid: "",
      description: "",
      amount: 0,
    };

    setRowsData([...rowsData, rowsInput]);
  };

  const clearcatgoery = () => {
    console.log("78787data");

    setRowsData([]);
  };

  const PaymentMethodAPI = () => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/transactionpaymentdropdown?module=receive_payment`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const Option = res.data.ResponseData.map((u) => ({
          label: u.Paymenttypename,
          value: u.ID,
          paymentquickbookid: u.PaymentQuickbookId,
        }));

        setPaymentMethod(Option);
      });
  };

  const handleTagsDropdowns = () => {
    // tags dropdown values
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("tags ==>", res.data.ResponseData);
        setTagsdropdwonData(res.data.ResponseData);
        return res;
      });
  };

  //Api calls

  console.log(paymentQB, "label");
  const handlesubmit = () => {
    if (paramObject?.id > 0 && ExpenseTotal < AmountPaid) {
      toastError("Total amount Cannot Be less Than Total paid Amount ");
      return;
    }

    const Location = localStorage.getItem("Location");

    let categoryfilter = rowsData.filter((el) => {
      return el.accountid !== "";
    });

    let itemfilter = itemData.filter((el) => {
      return el.itemid !== "";
    });

    const Itemobj = {};
    Itemobj.categoryXML = categoryfilter; //Itemdata
    let categoryjsonstring = JSON.stringify(Itemobj);

    const Itemobjs = {};
    Itemobjs.itemXML = itemfilter; //Itemdata
    let itemjsonstring = JSON.stringify(Itemobjs);

    let reqobj = {
      xmlCategorys: categoryjsonstring,
      XMLitems: itemjsonstring,
      Payeeid: selectpayee,
      payeetypeid: payeetypeid,
      accountid: selectedaccount,
      paymentMethodId: paymentMethodId,
      referenceNumber: referenceNumber,
      Total: ExpenseTotal,
      ExpenseDate: ExpenseDate,
      Location: Location,
      ID: paramObject.id || 0,
      loginuserid: Id,
      memo: memo,
      QuickbookPayee: QuickbookPayee,
      Quickbookaccount: Quickbookaccount,
      trnQuickbookid: trnQuickbookid,
      paymentQB: paymentQB,
      QBPaymentmethod: QBPaymentmethod,
    };

    console.log(JSON.stringify(reqobj), "reqobjdata");
    setLoading(true);
    axios
      .post(`${config.receivingBaseUrl}/receivings/Expenseupsert`, reqobj, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          localStorage.removeItem("ExpenseDraft");

          toastSuccess(res.data.ResponseMessage);
          navigate(`/receiving-receipt/${res.data.ResponseID[0].ID}`);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/payeedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log(response.data.ResponseData, "datadone=======.");
        setPayeeOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);

        setAccount(res.data.ResponseData);
      });

    PaymentMethodAPI();
    handleTagsDropdowns();

    if (paramObject.id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.receivingBaseUrl}/receivings/listofsuspendrecordByidv2?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const SuspendedData = res.data.ResponseData.unSuspendData[0];
          const ExpenseItem = res.data.ResponseData.receivingItem?.filter(
            (el) => {
              return el.Module == "Item";
            }
          );

          const Expensecategory = res.data.ResponseData.receivingItem?.filter(
            (el) => {
              return el.Module == "Accounts";
            }
          );

         setAmountPaid(SuspendedData?.AmountPaid == '0.00' ? 0 : SuspendedData?.AmountPaid);
          let Expensecategorys = Expensecategory.map((el) => ({
            id: el.ReceivingItemID,
            accountid: el.ItemId,
            description: el.Description,
            amount: el.Total,
            Module: el.Module,
            QuickbookId: el.itemquickbookid,
          }));

          setRowsData(Expensecategorys);

          let expenseitems = ExpenseItem.map((el) => ({
            id: el.ReceivingItemID,
            itemid: el.VariationId > 0 ? el.VariationId : el.ItemId,
            sku: "",
            description: el.Description,
            qty: el.QuantityReceived,
            rate: el.UnitPrice,
            amount: el.Total,
            Module: el.Module,
            QuickbookId: el.itemquickbookid,
          }));
          setitemData(expenseitems);

          setmemo(SuspendedData?.Comments);
          setselectpayee(SuspendedData?.Supplier);
          setpayeetypeid(SuspendedData?.PayeeType);
          settrnQuickbookid(SuspendedData?.QuickbookId);

          setPaymentMethodId(SuspendedData?.PaymentmethodId);
          let label = paymentMethod.find(
            (el) => el.value == SuspendedData?.PaymentmethodId
          );
          setpaymentQB(label?.label);
          setQBPaymentmethod(label?.paymentquickbookid);
          setQuickbookPayee(
            res.data.ResponseData.supplierdetail[0].QuickBookId
          );
          setquickbookaccount(SuspendedData?.accountquickbookidexpense);
          setSelectedAccount(SuspendedData?.AccountID);
          let account =
            AccontDDL.find(
              (option) => option?.value == SuspendedData?.AccountID
            ) || "";
          console.log(account, "ExpenseItem");
          setselectedaccountbal(account?.Amount);
          setReferenceNumber(SuspendedData?.BillNo);
          setexpensedate(SuspendedData?.Date);
          setExpenseTotal(SuspendedData?.total);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }, []);

  useEffect(() => {
    let Total = calculateTotal();
    setExpenseTotal(Total);
  }, [rowsData, itemData]);
  useEffect(() => {
    const tagValue = selectedtags?.map((e) => Number(e));
    const filteredTagsData = TagsList?.filter((tag) =>
      tagValue?.includes(tag.value)
    );
    setTag(filteredTagsData);
  }, [selectedtags]);
  // Dropdowns

  let TagsList = [];
  const Tags = tagsdropdwonData.map((u, i) => {
    TagsList[i] = { label: u.Name, value: u.ID };
  });

  let payeeoption = [];
  const manufacturedropdownvalue = payeeoptions.map((u, i) => {
    payeeoption[i] = {
      label: u.CompanyName,
      value: u.ID,
      Type: u.Type,
      QuickBookId: u.QuickBookId,
    };
  });

  let AccontDDL = [];
  const manufacturedropdownvalues = Account.map((u, i) => {
    AccontDDL[i] = {
      label: u.Name,
      value: u.ID,
      Amount: u.Amount,
      QuickBookId: u.QuickbookId,
    };
  });

  // Local Drafting handling

  useEffect(() => {
    const Draftdata = JSON.parse(localStorage.getItem("ExpenseDraft"));
    console.log(Draftdata, "ExpenseDraft");
    if (paramObject.id === undefined && Draftdata !== null) {
      setPaymentMethodId(Draftdata?.paymentMethodId);
      setselectpayee(Draftdata?.payee);
      setpayeetypeid(Draftdata?.payeetypeid);
      setQuickbookPayee(Draftdata?.payeeqb);
      setSelectedAccount(Draftdata?.Selectedaccount);
      setquickbookaccount(Draftdata?.quickbookaccount);
      setReferenceNumber(Draftdata?.referenceNumber);
      setpaymentQB(Draftdata?.Paymenttypename);
      setQBPaymentmethod(Draftdata?.qbPaymentmethod);
      setselectedaccountbal(Draftdata?.selectedaccountbal);
      if (Draftdata?.Categorysection?.length > 0) {
        setRowsData(Draftdata?.Categorysection);
      }
      if (Draftdata?.Itemsection?.length > 0) {
        setitemData(Draftdata?.Itemsection);
      }
      setmemo(Draftdata?.memo);
    }
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row">
              <div className="breadcrumb-position">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Expense </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card-header">
            <div className="row">
              <div className="col-sm-3">
                <label className="col-form-label col-md-12 form-label">
                  Payee
                  <span className="text-danger">*</span>
                </label>

                <div className="col-md-9">
                  <div>
                    <Select
                      className="custom-search-select"
                      name="supplierid"
                      id="supplierid"
                      placeholder="Select Payee"
                      options={payeeoption}
                      onChange={(e) => {
                        if (!AmountPaid > 0) {
                          handlepayee(e);
                        }
                      }}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={
                        payeeoption.find(
                          (option) => option?.value == selectpayee
                        ) || ""
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-sm-4">
                <div className="row">
                  <label className="col-form-label col-md-12 form-label">
                    Account
                    <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <Select
                      className={` custom-search-select`}
                      value={
                        AccontDDL.find(
                          (option) => option?.value == selectedaccount
                        ) || ""
                      }
                      onChange={handleaccount}
                      options={AccontDDL}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      id="Account"
                      name="Account"
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    />
                  </div>
                  <div className="col-sm-4 pt-2">
                    <label className="col-form-label ">
                      Balance :
                      {CurrencySymbols(
                        selectedaccountbal || 0,
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-sm-2"></div>
              <div className="col-sm-1"></div>

              <div className="col-sm-2">
                <p>AMOUNT</p>
                <label
                  className="col-md-7  "
                  style={{ fontWeight: "bold", fontSize: "35px" }}
                >
                  {CurrencySymbols(
                    Number(ExpenseTotal),
                    CurrencySymbol,
                    FractionDigits
                  )}
                </label>
              </div>
            </div>
            <div className="row pt-3 d-flex justify-content-between align-items-start">
              {/* Payment Date */}
              <div className="col-md-2">
                <p className="col-form-label">Payment Date:</p>
                <CommonDatePicker
                  FinalDate={ExpenseDate}
                  handleDateChange={setexpensedate}
                />
              </div>

              {/* Payment Method */}
              <div className="col-md-2">
                <p className="col-form-label">Payment Method:</p>
                <div>
                  <Select
                    options={paymentMethod}
                    placeholder="Select Method"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="PaymentMethod"
                    name="PaymentMethod"
                    onChange={(event) => handleChangePaymet(event)}
                    value={paymentMethod?.find(
                      (option) => option.value === paymentMethodId
                    )}
                    className="custom-search-select"
                  />
                </div>
              </div>

              {/* Reference Number */}
              <div className="col-md-2">
                <p className="col-form-label">Reference Number:</p>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Ref No."
                  name="ReferenceNumber"
                  id="ReferenceNumber"
                  onChange={(event) => handleChangeRefno(event)}
                  value={referenceNumber}
                />
              </div>
              <div className="col-md-6"></div>
            </div>
            <div className="row pt-3 d-flex justify-content-between align-items-start">
              <div className="row">
                <div className="row mt-3">
                  <label className="form-label">Tags</label>
                  <div className="col-md-5">
                    <div className="input-group">
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        // isClearable={true}
                        isMulti={true}
                        onChange={handleSelectedtags}
                        options={TagsList}
                        placeholder=""
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Tags"
                        name="Tags"
                        className="w-75  custom-search-select"
                        value={tag}
                      />

                      <button
                        type="button"
                        className="btn btn-sm btn-secondary ml-2"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModal"
                        onClick={() => handeltagsmodelShow()}
                      >
                        Add Tags
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <h6 onClick={() => setcategorydetiles(!Categorydetiles)}>
              {Categorydetiles == true ? "v" : "＞"} Category Detiles
            </h6>
            {Categorydetiles ? (
              <>
                <div className="">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="p-regular" width="3%">
                          #
                        </th>
                        <th className="p-regular" width="25%">
                          Category
                        </th>
                        <th className="p-regular" width="45%">
                          Description
                        </th>
                        <th className="p-regular" width="15%">
                          Amount
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <Expensecategoryrows
                        rowsData={rowsData}
                        deleteTableRows={deleteTableRows}
                        handleChange={handleChangeTableRow}
                        callback={callback}
                      />
                    </tbody>
                  </table>

                  <div className="form-group row mb-4">
                    <div className="col-sm-6 ">
                      <button
                        type="button"
                        className="btn btn-secondary mt-1  btn-sm pull-left mt-3"
                        onClick={addTableRows}
                        disabled={rowsData.length == 30 ? true : false}
                      >
                        <i className="fa fa-plus fa-sm " /> Add
                      </button>
                      <button
                        type="button"
                        onClick={clearcatgoery}
                        className="btn btn-secondary ms-1  btn-sm pull-left mt-3"
                      >
                        Clear lines
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            <h6
              style={{ fontsize: "25px" }}
              onClick={() => setitemdetiles(!itemdetiles)}
            >
              {itemdetiles == true ? "v" : "＞"} Item Detiles
            </h6>

            {itemdetiles ? (
              <>
                <div className="">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="p-regular" width="3%">
                          #
                        </th>
                        <th className="p-regular" width="25%">
                          PRODUCT / SERVICES
                        </th>
                        <th className="p-regular" width="15%">
                          SKU
                        </th>
                        <th className="p-regular" width="15%">
                          Description
                        </th>
                        <th className="p-regular" width="15%">
                          QTY
                        </th>
                        <th className="p-regular" width="15%">
                          RATE
                        </th>
                        <th className="p-regular" width="15%">
                          AMOUNT
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ExpenseItemrows
                        rowsData={itemData}
                        deleteTableRows={deleteitemTableRows}
                        handleChange={handleChangeItemTableRow}
                        callback={callback}
                      />
                    </tbody>
                  </table>

                  <div className="form-group row mb-4">
                    <div className="col-sm-6 ">
                      <button
                        type="button"
                        className="btn btn-secondary mt-1  btn-sm pull-left mt-3"
                        onClick={additemTableRows}
                      >
                        <i className="fa fa-plus fa-sm " /> Add
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary ms-1  btn-sm pull-left mt-3"
                        onClick={() => clearitem}
                      >
                        Clear lines
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
            }}
          >
            <h6 style={{ marginRight: "30px" }}> Total : </h6>
            <h6 style={{ marginRight: "30px" }}>
              {" "}
              {CurrencySymbols(
                Number(ExpenseTotal),
                CurrencySymbol,
                FractionDigits
              )}
            </h6>
          </div>
          <div className="row">
            <div className="col-sm-2">
              <div className="form-group ">
                <label className="col-form-label col-md-1 form-label">
                  Memo
                </label>
                <div className=" col-md-12  mt-2">
                  <textarea
                    rows="8"
                    cols="50"
                    value={memo}
                    onChange={Handelmemo}
                  ></textarea>
                </div>
              </div>
            </div>

            {/* row 5 */}
            <div className="col-sm-3">
              <div className="form-group ">
                <label className="col-form-label col-md-3 form-label">
                  Attachments
                </label>
                <div className="col-md-9 dotted-border p-3 mt-5">
                  <input
                    id="SelectImage"
                    name="SelectImage"
                    type="file"
                    value={selectedImage}
                    accept="image/*"
                    handleChange={_handleFileChange}
                    className="form-control form-control-sm"
                  />
                  {ImageUrl && (
                    <Link to={ImageUrl} target="_blank">
                      Attachment Link
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-5"></div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
            }}
          >
            <button
              type="submit"
              className="btn btn-sm btn-primary mt-3 mb-3"
              onClick={() => {
                handlesubmit();
              }}
            >
              Save & Close
            </button>
            <button
              type="submit"
              className="btn btn-sm btn-secondary mt-3 mb-3"
              onClick={() => {
                handlesubmit();
              }}
            >
              Save & New
            </button>
            <button
              className="btn btn-sm btn-secondary mt-3 mb-3"
              onClick={() => {
                localStorage.removeItem("ExpenseDraft");
                window.location.reload();
              }}
            >
              Clear data
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={showtag}
        onHide={handleClose}
        className="modal-lg"
        id="ManageDataModal"
      >
        <Modal.Header>
          <Modal.Title>Add Tags </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handeltagsmodelClose}
          >
            x
          </button>
        </Modal.Header>
        <Formik
          {...props}
          initialValues={formValuesfortagmodel}
          onSubmit={handleSubmitformodeltags}
          enableReinitialize
        >
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
              <Loader loading={loading} />
              <div className="modal-body">
                <div className="form-group row">
                  <label className="col-form-label col-md-3 align-center">
                    Tags
                  </label>
                  <div className="col-md-9 mt-2">
                    <Field
                      type="text"
                      name="Tags"
                      id="Tags"
                      placeholder="Enter Tag Name"
                      className="form-control form-control-sm"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-lg-12 justify-content-right">
                  <button type="submit" className="btn btn-primary btn-md me-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-dark btn-md me-1"
                    onClick={handeltagsmodelClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default ExpenseQuickbook;
